import classNames from "classnames";
import React from "react";
import { t } from "ttag";

import { QuickSearchItem } from "../models";

export const LocatorQuickSearch = (props: {
    items: QuickSearchItem[];
    selectedItem: string | undefined;
}) => (
    <nav className="quicksearch__nav" aria-label={t`Quick Search`}>
        <ul className="quicksearch__nav-list" role="list">
            {props.items.map((item) => (
                <li
                    key={item.id}
                    className={classNames({
                        "quicksearch__nav-item": true,
                        "al-store-locator__nav-item--quicksearch": true,
                        "quicksearch__nav-item--selected":
                            props.selectedItem === item.id,
                    })}
                >
                    <a
                        className={`quicksearch__nav-button ${item.labelClassName}`}
                        href={item.href}
                        aria-current={
                            props.selectedItem === item.id ? "true" : undefined
                        }
                    >
                        <div className="quicksearch__nav-img-wrapper">
                            <img
                                className="quicksearch__nav-img"
                                alt={item.imgAlt}
                                src={item.imgSrc}
                            />
                        </div>
                        <span className="quicksearch__nav-title">
                            {item.title}
                        </span>
                    </a>
                    <div className="quicksearch__nav-descript">
                        {item.descr}
                    </div>
                </li>
            ))}
        </ul>
    </nav>
);
